// Mock data for Elite Real Estate

export const properties = [
  {
    id: 1,
    title: 'Luxury Penthouse in Mayfair',
    price: 2850000,
    location: 'Mayfair, London W1',
    bedrooms: 3,
    bathrooms: 2,
    sqft: 1850,
    type: 'Penthouse',
    status: 'For Sale',
    image: 'https://images.unsplash.com/photo-1632743441209-8a09b8a37e25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBsb25kb24lMjBhcGFydG1lbnRzfGVufDB8fHx8MTc1ODk3OTY2NHww&ixlib=rb-4.1.0&q=85',
    gallery: [
      'https://images.unsplash.com/photo-1632743441209-8a09b8a37e25?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBsb25kb24lMjBhcGFydG1lbnRzfGVufDB8fHx8MTc1ODk3OTY2NHww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3NTg5Nzk2NzB8MA&ixlib=rb-4.1.0&q=85'
    ],
    description: 'Stunning penthouse with panoramic city views, featuring modern design and premium finishes throughout.',
    features: ['City Views', 'Modern Kitchen', 'Private Terrace', 'Concierge Service']
  },
  {
    id: 2,
    title: 'Victorian Townhouse in Kensington',
    price: 4200000,
    location: 'Kensington, London SW7',
    bedrooms: 5,
    bathrooms: 4,
    sqft: 3200,
    type: 'Townhouse',
    status: 'For Sale',
    image: 'https://images.unsplash.com/photo-1722293862101-6511f044073b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBsb25kb24lMjBhcGFydG1lbnRzfGVufDB8fHx8MTc1ODk3OTY2NHww&ixlib=rb-4.1.0&q=85',
    gallery: [
      'https://images.unsplash.com/photo-1722293862101-6511f044073b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBsb25kb24lMjBhcGFydG1lbnRzfGVufDB8fHx8MTc1ODk3OTY2NHww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3NTg5Nzk2NzB8MA&ixlib=rb-4.1.0&q=85'
    ],
    description: 'Beautifully restored Victorian townhouse with period features and contemporary amenities.',
    features: ['Period Features', 'Garden', 'Off-Street Parking', 'High Ceilings']
  },
  {
    id: 3,
    title: 'Modern Apartment in Canary Wharf',
    price: 1650000,
    location: 'Canary Wharf, London E14',
    bedrooms: 2,
    bathrooms: 2,
    sqft: 1200,
    type: 'Apartment',
    status: 'For Sale',
    image: 'https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg',
    gallery: [
      'https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg',
      'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3NTg5Nzk2NzB8MA&ixlib=rb-4.1.0&q=85'
    ],
    description: 'Contemporary apartment in prestigious Canary Wharf with excellent transport links.',
    features: ['River Views', 'Gym', 'Concierge', '24/7 Security']
  },
  {
    id: 4,
    title: 'Luxury Mews House in Chelsea',
    price: 3750000,
    location: 'Chelsea, London SW3',
    bedrooms: 4,
    bathrooms: 3,
    sqft: 2400,
    type: 'Mews House',
    status: 'For Sale',
    image: 'https://images.pexels.com/photos/1571459/pexels-photo-1571459.jpeg',
    gallery: [
      'https://images.pexels.com/photos/1571459/pexels-photo-1571459.jpeg',
      'https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3NTg5Nzk2NzB8MA&ixlib=rb-4.1.0&q=85'
    ],
    description: 'Charming mews house in the heart of Chelsea with private courtyard and modern interiors.',
    features: ['Private Courtyard', 'Modern Design', 'Quiet Location', 'Premium Finishes']
  },
  {
    id: 5,
    title: 'Riverside Apartment in Battersea',
    price: 2100000,
    location: 'Battersea, London SW11',
    bedrooms: 3,
    bathrooms: 2,
    sqft: 1400,
    type: 'Apartment',
    status: 'For Sale',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3NTg5Nzk2NzB8MA&ixlib=rb-4.1.0&q=85',
    gallery: [
      'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3NTg5Nzk2NzB8MA&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3NTg5Nzk2NzB8MA&ixlib=rb-4.1.0&q=85'
    ],
    description: 'Elegant riverside apartment with stunning Thames views and luxury amenities.',
    features: ['Thames Views', 'Balcony', 'Parking', 'Gym Access']
  },
  {
    id: 6,
    title: 'Georgian House in Bloomsbury',
    price: 5200000,
    location: 'Bloomsbury, London WC1',
    bedrooms: 6,
    bathrooms: 5,
    sqft: 4100,
    type: 'House',
    status: 'For Sale',
    image: 'https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3NTg5Nzk2NzB8MA&ixlib=rb-4.1.0&q=85',
    gallery: [
      'https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3NTg5Nzk2NzB8MA&ixlib=rb-4.1.0&q=85',
      'https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg'
    ],
    description: 'Magnificent Georgian house with original features and modern comforts in historic Bloomsbury.',
    features: ['Original Features', 'Garden', 'Wine Cellar', 'Period Details']
  }
];

export const teamMembers = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    position: 'Senior Sales Director',
    image: 'https://images.unsplash.com/photo-1581065178047-8ee15951ede6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NTg5MjQzNjB8MA&ixlib=rb-4.1.0&q=85',
    bio: 'With over 15 years in London\'s luxury property market, Sarah specializes in high-end residential sales in Mayfair and Kensington.',
    email: 'sarah.mitchell@eliterealestate.com',
    phone: '+44 20 7123 4567'
  },
  {
    id: 2,
    name: 'James Rodriguez',
    position: 'Property Investment Advisor',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NTg5MjQzNjB8MA&ixlib=rb-4.1.0&q=85',
    bio: 'James helps clients build profitable property portfolios across London, with expertise in emerging markets and investment strategies.',
    email: 'james.rodriguez@eliterealestate.com',
    phone: '+44 20 7123 4568'
  },
  {
    id: 3,
    name: 'Emma Thompson',
    position: 'Lettings Manager',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NTg5MjQzNjB8MA&ixlib=rb-4.1.0&q=85',
    bio: 'Emma manages our prestigious lettings portfolio, ensuring seamless experiences for both landlords and tenants in Central London.',
    email: 'emma.thompson@eliterealestate.com',
    phone: '+44 20 7123 4569'
  },
  {
    id: 4,
    name: 'Michael Chen',
    position: 'Marketing Director',
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHRlYW18ZW58MHx8fHwxNzU4OTc5NzAwfDA&ixlib=rb-4.1.0&q=85',
    bio: 'Michael leads our marketing team, creating compelling campaigns that showcase London\'s finest properties to discerning buyers worldwide.',
    email: 'michael.chen@eliterealestate.com',
    phone: '+44 20 7123 4570'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'David Williams',
    role: 'Property Investor',
    content: 'Elite Real Estate helped us sell our Kensington property in under 2 weeks! Their market knowledge and professional approach exceeded our expectations.',
    rating: 5
  },
  {
    id: 2,
    name: 'Catherine Miller',
    role: 'First-time Buyer',
    content: 'The team made buying our first home stress-free. Sarah guided us through every step and found us the perfect apartment in Canary Wharf.',
    rating: 5
  },
  {
    id: 3,
    name: 'Robert Johnson',
    role: 'Property Developer',
    content: 'Outstanding service from start to finish. Their investment advice has been invaluable for our London property portfolio.',
    rating: 5
  }
];

export const services = [
  {
    id: 1,
    title: 'Property Sales',
    description: 'Expert guidance through the entire sales process, from valuation to completion.',
    features: ['Free Property Valuation', 'Professional Photography', 'Marketing Strategy', 'Negotiation Support']
  },
  {
    id: 2,
    title: 'Property Lettings',
    description: 'Comprehensive lettings service for landlords and tenants in prime London locations.',
    features: ['Tenant Sourcing', 'Property Management', 'Rent Collection', 'Maintenance Coordination']
  },
  {
    id: 3,
    title: 'Investment Advisory',
    description: 'Strategic investment advice to help you build a profitable property portfolio.',
    features: ['Market Analysis', 'Investment Strategy', 'Portfolio Management', 'ROI Optimization']
  },
  {
    id: 4,
    title: 'Property Management',
    description: 'Full-service property management for landlords and property investors.',
    features: ['24/7 Support', 'Maintenance Services', 'Financial Reporting', 'Legal Compliance']
  }
];

export const stats = [
  { label: 'Properties Sold', value: '500+' },
  { label: 'Years of Experience', value: '15+' },
  { label: 'Happy Clients', value: '1000+' },
  { label: 'London Boroughs Covered', value: '25+' }
];